'use client';

import { ReactNode } from 'react';

import { Analytics } from '@monoimin/utils/analytics';

import type { C2AAnalyticsClientProps, Locales } from '@monoimin/sb-types';

export const TrackBlockClick = ({
  children,
  data,
  locale,
  className,
  actionName,
  withGTM = true,
}: {
  className?: string;
  data: C2AAnalyticsClientProps; // TODO: TrackBlockClick следит не за C2A событиями, нужен отдельный тип
  locale: Locales;
  children: ReactNode;
  actionName: string;
  withGTM?: boolean;
}) => {
  const track = () => {
    const finalData: any = {
      // TODO: создать отдельный тип
      ...data,
      language: locale,
      block_element_click: 'button',
      block_action: 'click',
    };

    const renta = new Analytics();

    renta.track(actionName, finalData);

    if (withGTM && typeof window !== 'undefined' && window?.dataLayer?.push) {
      window.dataLayer.push({
        event: 'block_clicks',
        cta_block_category: data.block_type,
        cta_block_name: data.block_name as string,
        attribute_name: (data as any).element_click_description as string, // TODO: убрать any, когда будет готов тип
        attribute_url: data.element_click_url as string,
      });
    }
  };
  return (
    <div className={className} onClick={() => track()}>
      {children}
    </div>
  );
};
